require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/es6.typed.int32-array.js
// module id = 263
// module chunks = 0